import { Grid } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import Title from "../ReusableComponents/title";
import "../../assets/css/accountmetrics.scss";
import ProgressBar from "../ReusableComponents/ProgressBar";
import AMTooltip from "../ReusableComponents/AMTooltip";
import { dollarUS } from "../../utilities/formatters";
import SymbolChart from "../Admin/Charts/SymbolChart";
import AMStatCards from "../ReusableComponents/AMStatCards";

const AdvancedStaistics = ({ TradeSummary, AdvStats, DailySummary, data }) => {
  const [TooltipShow, setTooltipShow] = useState(false);
  const [closeTooltip, setCloseTooltip] = useState(false);

  const ref = useRef(null);

  console.log(TradeSummary, AdvStats, data);

  const tooltipChange = (e) => {
    e.preventDefault();
    var tooltip = e.currentTarget.textContent;

    if (TooltipShow === tooltip) {
      //   alert('Tooltip is already open')
      setTooltipShow(false);
    } else {
      setTooltipShow(tooltip);
      setCloseTooltip(!TooltipShow);
    }
  };
  const handleClose = (e) => {
    e.preventDefault();
    // setTooltipShow(false)
  };

  useEffect(() => {
    const checkOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setTooltipShow(false);
      }
    };
    document.addEventListener("click", checkOutside);
    return () => {
      document.removeEventListener("click", checkOutside);
    };
  }, [TooltipShow]);

  console.log("AdvStats", AdvStats);

  return (
    <div className="AdvancedStaisticsContainer">
      <div onClick={handleClose} className="AdvancedStaisticsBox">
        <div className=" wholeAdVI">
          <div className="advStatsCountryContainer">
            <div className="advStatsCountryWrapper">
              <div
                className="AdvancedStatisticsContainer AMCardsBox_tradelot"
                style={{ order: 4 }}
              >
                {AdvStats &&
                AdvStats.symbols &&
                Object.keys(AdvStats.symbols).length > 0 ? (
                  Object.keys(AdvStats.symbols).map((info) => {
                    return (
                      <AMStatCards
                        key={info}
                        AMCurrencyName={info}
                        Num1={
                          AdvStats.symbols[info].lots &&
                          AdvStats.symbols[info].lots.toFixed(2)
                        }
                        Num3={
                          AdvStats.symbols[info].profit &&
                          AdvStats.symbols[info].profit.toFixed(2)
                        }
                      />
                    );
                  })
                ) : (
                  <div className="no-data">No Data Available</div>
                )}
              </div>
            </div>
          </div>

          <div className={"AdvancedStaisticsBoxContainer wholeADVL"}>
            <h3>Advanced Statistics </h3>
            <div className="AdvancedStaisticsBoxWrapper">
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three>Trades</Title>
                  </Grid>
                  <Grid textAlign={"right"}>
                    <Title four>
                      {AdvStats &&
                        AdvStats.total_trades &&
                        AdvStats.total_trades}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Longs Won:{" "}
                      <span className="span_div">
                        {AdvStats && AdvStats.long_won && AdvStats.long_won}
                      </span>
                    </Title>
                    <Title three>
                      Profit Factor :
                      <span>
                        {data &&
                          data.profit &&
                          Number(data.profit_factor).toFixed(4)}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three>Profitability</Title>
                  </Grid>
                  <Grid textAlign={"right"}>
                    <Title four>
                      {AdvStats &&
                        AdvStats.Profit &&
                        AdvStats.Profit?.toFixed(2)}
                    </Title>
                  </Grid>
                  {/* <Grid className="ProgressBar">
                    <ProgressBar
                      bgcolor="#37C976"
                      progress={AdvStats && AdvStats.Profit * 100}
                      // progress={
                      //   (TradeSummary &&
                      //     (TradeSummary.totalWon /
                      //       (Math.abs(TradeSummary.totalWon) +
                      //         Math.abs(TradeSummary.totalLost))) *
                      //       100) ||
                      //   0
                      // }
                    />
                  </Grid> */}
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Shorts Won:{" "}
                      <span>
                        {AdvStats && AdvStats.short_won && AdvStats.short_won}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three>Pips</Title>
                  </Grid>
                  <Grid>
                    <Title four>
                      {AdvStats && AdvStats.pips && AdvStats.pips}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Best Trade:{" "}
                      <span>
                        {AdvStats &&
                          AdvStats.best_trade &&
                          dollarUS(AdvStats.best_trade)}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three StyleName="Positive">
                      Average Win
                    </Title>
                  </Grid>
                  <Grid>
                    <Title four StyleName="Positive">
                      {AdvStats &&
                        AdvStats.average_win &&
                        dollarUS(AdvStats.average_win.toFixed(2))}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Worst Trade:
                      <span>
                        {AdvStats &&
                          AdvStats.worst_trade &&
                          dollarUS(AdvStats.worst_trade)}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  {" "}
                  <Grid xs={12}>
                    <Title three StyleName="Negative avgLossRed">
                      Average Loss
                    </Title>
                  </Grid>
                  <Grid>
                    <Title four StyleName="Negative avgLossRed">
                      {AdvStats &&
                        AdvStats.average_loss &&
                        dollarUS(AdvStats.average_loss.toFixed(2))}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Best Trade (Pips):{" "}
                      <span>
                        {AdvStats &&
                          AdvStats.best_trade_pip &&
                          Number(AdvStats.best_trade_pip).toFixed(2)}
                      </span>
                    </Title>
                    <Title three>
                      Expectancy
                      <span style={{ marginLeft: "5px" }}>
                        {data &&
                          data.expectancy_ratio &&
                          Number(data.expectancy_ratio).toFixed(4)}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three>Lots</Title>
                  </Grid>
                  <Grid>
                    <Title four>
                      {AdvStats && AdvStats.lots && AdvStats.lots.toFixed(2)}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Worst Trade (Pips):{" "}
                      <span>
                        {AdvStats &&
                          AdvStats.worst_trade_pip &&
                          Number(AdvStats.worst_trade_pip).toFixed(2)}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                <div className="topSectionData">
                  <Grid xs={12}>
                    <Title three>Commissions</Title>
                  </Grid>
                  <Grid>
                    <Title four>
                      {AdvStats && AdvStats.commission && AdvStats.commission}
                    </Title>
                  </Grid>
                </div>
                <div className="bottomSectionData">
                  <Grid>
                    <Title three>
                      Avg. Trade Length:{" "}
                      <span>
                        {AdvStats &&
                          AdvStats.average_trade_length &&
                          AdvStats.average_trade_length}
                      </span>
                    </Title>
                  </Grid>
                </div>
              </div>
              <div className="advanceStatisticsBox">
                {/* <Grid>
                  <Title three>Profit Factor</Title>
                </Grid>
                <Grid>
                  <Title four>
                    {data &&
                      data.profit_factor &&
                      Number(data.profit_factor).toFixed(4)}
                  </Title>
                </Grid> */}
              </div>
            </div>
          </div>

          {/* <div className={"AdvancedStaisticsBoxContainer CHART"}>
            <SymbolChart data={AdvStats && AdvStats.symbols} />
          </div>

     */}
        </div>
      </div>{" "}
      {/* <div className="text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>Profit Factor</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        <div>
          {TooltipShow === "Profit Factor" && (
            <AMTooltip
              TooltipClass={closeTooltip ? "app" : "hi"}
              HeadTooltip="Profit Factor"
              DescTooltip="geometric Average holding period, or GHPR, 
                  is the profits if compounded. A GHPR<0% means 
                  that system will lose money if compunded."
            />
          )}
        </div>
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>Standard Deviation</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "Standard Deviation" && (
          <AMTooltip
            HeadTooltip="Standard Deviation"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>Sharpe Ratio</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "Sharpe Ratio" && (
          <AMTooltip
            HeadTooltip="Sharpe Ratio"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>Z-Score (Probability)</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "Z-Score (Probability)" && (
          <AMTooltip
            HeadTooltip="Z-Score (Probability)"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>Expectancy</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "Expectancy" && (
          <AMTooltip
            HeadTooltip="Expectancy"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>AHPR</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "AHPR" && (
          <AMTooltip
            HeadTooltip="AHPR"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div>
      <div className=" text-align-left mbb-20">
        <div className="d-flex">
          <Grid xs={5} onClick={tooltipChange} className="LinkTexts">
            <Title three>GHPR</Title>
          </Grid>
          <Grid xs={5}>
            <Title four>{}</Title>
          </Grid>
        </div>
        {TooltipShow === "GHPR" && (
          <AMTooltip
            HeadTooltip="GHPR"
            DescTooltip="geometric Average holding period, or GHPR, 
                                is the profits if compounded. A GHPR<0% means 
                                that system will lose money if compunded."
          />
        )}
      </div> */}
    </div>
  );
};
export default AdvancedStaistics;

export const CountryData = ({ AdvStats }) => {
  const hasData =
    AdvStats && AdvStats.symbols && Object.keys(AdvStats.symbols).length > 0;

  return (
    <div
      className="AdvancedStatisticsContainer AMCardsBox_tradelot"
      style={{ order: 4 }}
    >
      {hasData ? (
        Object.keys(AdvStats.symbols).map((info) => {
          return (
            <AMStatCards
              key={info}
              AMCurrencyName={info}
              Num1={
                AdvStats.symbols[info].lots &&
                AdvStats.symbols[info].lots.toFixed(2)
              }
              Num3={
                AdvStats.symbols[info].profit &&
                AdvStats.symbols[info].profit.toFixed(2)
              }
              tradelots={true}
            />
          );
        })
      ) : (
        <div className="no-data">No Data Available</div>
      )}
    </div>
  );
};
